package top.wcpe.allincore.ui.runtime.protocol

/** JS：最小数据实现（mock 数据层构造物品线报文用）。 */
actual class ItemStackViewWire(
    private val itemId: String?,
    private val count: Int,
    private val durability: Float,
    private val cooldown: Float,
    private val maxStackSize: Int,
    private val nbtBytes: ByteArray?,
) {

    actual fun getItemId(): String? = itemId

    actual fun getCount(): Int = count

    actual fun getDurability(): Float = durability

    actual fun getCooldown(): Float = cooldown

    actual fun getMaxStackSize(): Int = maxStackSize

    actual fun getNbtBytes(): ByteArray? = nbtBytes
}

/** 与 JVM 真源常量一致（协议约定值，真源为 common-protocol-types）。 */
actual val itemStackNoDurability: Float = -1f

actual val itemStackDefaultMaxStack: Int = 64
